import { createAction, props } from '@ngrx/store';

export const loadMapControls = createAction('[MapControl] Load MapControls');

export const toggleMapControlsRedflagSelector = createAction('[MapControl] Toggle Redflag Selector');

export const setMapControlDrawMode = createAction('[MapControl Set Draw Mode', props<{ active: boolean }>());

export const toggleMapControlsEditMode = createAction('[MapControl] Toggle Edit Mode');

export const toggleDrawPolygonMode = createAction('[MapControl] Toggle Draw Polygon Mode');

export const toggleDrawFreehandMode = createAction('[MapControl] Toggle Draw Freehand Mode');

export const toggleMapControlsWaterways = createAction('[MapControl] Toggle Waterways Display');

export const toggleMapControlsStands = createAction('[MapControl] Toggle Selected Stands Display');

export const toggleMapControlsRoads = createAction('[MapControl] Toggle Roads Display');

export const toggleMapControlsBaseMap = createAction('[MapControl] Toggle Contour Base Map');

export const resetMapControls = createAction('[MapControl] Reset Map Controls');

export const toggleMapControlsForest = createAction('[MapControl] Toggle Species Selector');

export const toggleMapControlsPublicLand = createAction('[MapControl] Toggle Public Land Selector');

export const toggleMapControlsKMLUpload = createAction('[MapControl] Toggle KML Upload Selector');

export const setMapControlsDrawModeOff = createAction('[MapControl] Set Draw Mode to false');
